import api from "../api";
import { getJwt } from '@app/helpers';
import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

const controller = "crfRelatorioCicloOrcamentario"

export interface CrfRelatorioCapexManeger {
  numeroIniciativasDoAno: number;
  capexTotalDoAno: number;
  capexTotalDoAnoFormat: string;

  realizadoDoAnoAteOMesAnterios: number;
  realizadoDoAnoAteOMesAnteriosFormat: string;

  balance: number;
  balanceFormat: string;

  totalContratado: number;
  totalExecutado: number;
  totalRequisitado: number;

  totalContratadoFormat: string;
  totalExecutadoFormat: string;
  totalRequisitadoFormat: string;


  ContratadoMaisRequisitado: number;
  contratadoMaisRequisitadoFormt: number;

  totalCapex: number;

  listReportCapexManegerDiretoria: CrfRelatorioCapexManegerDiretoria[];

  orcado: number;
  orcadoFormat: string
  collunBMaisCDivididoPorA: string;
  collunDDivididoPorA: string;
  naoPrevisto: number;

  totalExecutadoGrafico: number;
  totalRequisitadoGrafico: number;
  totalContratadoTotalRequisitadoGrafico: number;
  contratadoMaisRequisitado: null;

  totalizadorOrcado: string;
  totalizadorRequistiado: string;
  totalizadorForcast: string;
  totalizadorExecutado: string;
  totalizadorContratado: string;
  totalizadorNaoPrevisto: string;
}

export interface CrfRelatorioCapexManegerDiretoria {
  sigla: string;

  contratado: number;
  requistiado: number;
  executado: number;
  forcast: number;

  contratadoFormat: string;
  requistiadoFormat: string;
  executadoFormat: string;
  forcastFormat: string;
  ader: string;
  collunBMaisCDivididoPorA: string;
  collunDDivididoPorA: string;
}

export interface ICrfRelatorioCicloOrcamentario {
  ano: number;
  colluns: CrfCollunTable[];
  resultTable: CrfResultTable[];
  categories: string[];
  series: CrfSeries[];
  title: string;

  serieDataExecutado: number[];
  serieDataOrcado: number[];
  serieDataForeCast: number[];


  serieDataExecutadoLinha: number[];
  serieDataOrcadoLinha: number[];
  serieDataForeCastLinha: number[];


  serieDataExecutadoMax: number;
  serieDataOrcadoMax: number;
  serieDataForeCastMax: number;


  serieDataExecutadoLinhaMax: number;
  serieDataOrcadoLinhaMax: number;
  serieDataForeCastLinhaMax: number;
}

export interface CrfCollunTable {
  title: string;
  dataIndex: string;
}

export interface CrfResultTable {
  janeiro: string,
  abril: string,
  agosto: string,
  descricao: string,
  dezembro: string,
  fevereiro: string,
  id: string

  julho: string,
  junho: string,
  maio: string,
  março: string,
  novembro: string,
  outubro: string,
  setembro: string,
}

export interface CrfSeries {
  type: string;
  name: string;
  data: number[];
}

export interface CrfCicloOrcamentarioRelatorio {
  valorTotalA: string;
  valorTotalB: string;
  valorTotalC: string;
  valorTotalD: string;
  valorTotalE: string;
  valorTotalF: string;
  valorTotalG: string;
  valorTotalH: string;

  valorTotalI: string;
  valorTotalJ: string;
  result: CrfCicloOrcamentarioRelatorioResult[];
}

export interface CrfCicloOrcamentarioRelatorioResult {
  saldoCapExDecimal: number;
  aContratarDecimal: number;
  forecastDecimal: number;
  compromissadoDecimal: number;
  requisitadoDecimal: number;
  executadoDecimal: number;
  contratadoDecimal: number;

  capexCicloAnoDecimal: number;
  forecastCicloAnoDecimal: number;
  capExDecimal: number;

  capexCicloAnoRfaDecimal: number;
  forecastCicloAnoRfaDecimal: number;

  diretoriaNome: string;
  diretoria: string;
  area: string;
  areaNome: string;
  departamento: string;
  departamentoNome: string;
  id: string;
  numeroLinha: string;
  nomeprojeto: string;
  planilhaRfaAtual: string;
  codProjeto: string;
  capExp: string;
  contratado: string;
  executado: string;
  requisitado: string;
  compromissado: string;
  aContratar: string;
  forecast: string;
  saldoCapEx: string;
  saldoCapExPercentual: string;
  saldoCapExPercentualCor: string;
}

export interface CrfCicloOrcamentarioProjetoDadosGerais {
  id: string;
  rfa: string;
  statusRfa: string;
  tapAtual: string;
  totvs: string;
  categoria: string;
  orcamentario: string;
  fase: string;
  diretoria: string;
  area: string;
  departamento: string;
  escopo: string;
  requisitosAmbientais: string;
  escopoTab: string;
  inicioBaselineBl: string;
  terminoBaselineBl: string;
  inicioRealFcst: string;
  terminoRealFcst: string;

  inicioBaseline: string;
  terminoBaseline: string;
  inicioRealForecast: string;
  terminoRealForecast: string;

  inicioReal: string;
  terminoReal: string;

  prioridade: string;
  faseTap: string;
  restricaoAmbientalTap: string;
  diligenciamento: string;

  codigo: string;
  nome: string;
  previsto: string;
  dataAprovacaoRfaFormatada: string;
  dataAprovacaoRfa: Date;

  pluriAnual: CrfCicloOrcamentarioProjetoDadosGeraisPluriAnual[];
  anual: CrfCicloOrcamentarioProjetoDadosGeraisAnual[];
}

export interface CrfCicloOrcamentarioProjetoDadosGeraisPluriAnual {
  id: string;
  capEx: string;
  contratado: string;
  executado: string;
  requisitado: string;
  compromissado: string;
  aContratar: string;
  forecast: string;
  saldoCapEx: string;
}

export interface CrfCicloOrcamentarioProjetoDadosGeraisAnual {
  id: string;
  capEx: string;
  contratado: string;
  executado: string;
  requisitado: string;
  compromissado: string;
  aContratar: string;
  forecast: string;
  saldoCapEx: string;
}

export interface CrfCicloOrcamentarioProjetoPacote {
  valorTotalA: string;
  valorTotalB: string;
  valorTotalC: string;
  valorTotalD: string;
  valorTotalE: string;
  valorTotalF: string;
  valorTotalG: string;
  valorTotalH: string;
  result: CrfCicloOrcamentarioProjetoPacoteResult[];
}

export interface CrfCicloOrcamentarioProjetoPacoteResult {
  codPacote: string;
  nomePacote: string;
  orcadoAno: number;
  orcadoAnoFormatado: string;
  contratado: number;
  contratadoFormatado: string;
  executado: number;
  executadoFormatado: string;
  requisitado: number;
  requisitadoFormatado: string;
  compromissado: string;
  aContratar: string;
  forcast: string;
  dataIndex: string;
  ordemInvestimentoCodPacote: string;
  ordemInvestimentoId: string;
  children: CrfCicloOrcamentarioProjetoPacoteResult[];
}

export interface CrfFiltros {
  codigoProjeto: string;
  nomeProjeto: string;
  requisitosAmbientais: string;
  classificaoRfa: string[];
  diretoria: string[];
  area: string[];
  departamento: string[];
  categoria: string[];
  tipo: string[];
  pacoteDisciplina: string[];
  pacoteTipo: string[];
  orcamentario: string[];
  fase: string[];
  trocarValor: boolean;
}

export const getAllCrfRelatorioExecutiveSummary = () =>
  api.get<CrfRelatorioCapexManeger>(`${controller}/crfRelatorioExecutiveSummary`);

export const getAllCrfRelatorioCurvaEconomica = () =>
  api.get<ICrfRelatorioCicloOrcamentario>(`${controller}/crfRelatorioCurvaEconomica`);

export const postGetAllCrfRelatorioControleRfa = (values: CrfFiltros) => {
  return api.post<CrfCicloOrcamentarioRelatorio>(`${controller}/postGetAllRelatorioControleRfa`, values, {
    disableNotification: 'true',
  });
};





export const getAllCrfRequisitadoAno = () =>
  api.get<CrfRelatorioCapexManeger>(`${controller}/crfRelatorioCapexManeger`);


export const getAllCrfRelatorioCicloOrcamentario = () =>
  api.get<ICrfRelatorioCicloOrcamentario>(`${controller}/crfRelatorioCicloOrcamentario`);

export const GraficoEconomicoCicloAnualProjeto = (id: any) => {
  return api.get<ICrfRelatorioCicloOrcamentario>(`${controller}/getAllReportCurvaEconomicoCicloAnualProjeto/${id}`);
}

export const GraficoEconomicoPlureAnualProjeto = (id: any) => {
  return api.get<ICrfRelatorioCicloOrcamentario>(`${controller}/getAllReportCurvaEconomicoCicloPluriAnualProjeto/${id}`);
}

export const getCicloOrcamentarioProjetoDadosGerais = (id: any) =>
  api.get<CrfCicloOrcamentarioProjetoDadosGerais>(
    `${controller}/getCicloOrcamentarioProjetoDadosGerais/${id}`,
  );

export const getCicloOrcamentarioProjetoPacote = (id: any) =>
  api.get<CrfCicloOrcamentarioProjetoPacote>(`${controller}/getCicloOrcamentarioProjetoPacote/${id}`);

  export const getCicloOrcamentarioProjetoPacoteTabela = (id: any) =>
  api.get<any>(`${controller}/getCicloOrcamentarioProjetoPacoteTabela/${id}`);

export const getCicloOrcamentarioProjetoPacotePluriAnual = (id: any) =>
  api.get<CrfCicloOrcamentarioProjetoPacote>(
    `${controller}/getCicloOrcamentarioProjetoPacotePluriAnual/${id}`,
  );

  export const getCicloOrcamentarioProjetoPacotePluriAnualTabela = (id: any) =>
  api.get<CrfCicloOrcamentarioProjetoPacote>(
    `${controller}/getCicloOrcamentarioProjetoPacotePluriAnualTabela/${id}`,
  );

export const postGetAllRelatorioCicloOrcamentario = (values: CrfFiltros) => {
  return api.post<CrfCicloOrcamentarioRelatorio>(
    `${controller}/postGetAllRelatorioCicloOrcamentario`,
    values,
    { disableNotification: 'true' },
  );
};

export const postGetAllRelatorioCicloOrcamentarioPluriAnual = (values: CrfFiltros) => {
  return api.post<CrfCicloOrcamentarioRelatorio>(
    `${controller}/postGetAllRelatorioCicloOrcamentarioPluriAnual`,
    values,
    { disableNotification: 'true' },
  );
};



export const relatorioExportExcel = (values: CrfFiltros) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.post(urlBase + `/api/${controller}/postGetAllRelatorioCicloOrcamentarioExportar`, values, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'relatorioCicloOrcamentarioExportar.xlsx');
      link.setAttribute('id', 'relatorioCicloOrcamentarioExportarId');
      document.body.appendChild(link);
      link.click();
      document.getElementById('relatorioCicloOrcamentarioExportarId').outerHTML = '';
    }),
  );
};

export const getCicloOrcamentarioProjetoPacoteExportaExcel = (id: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/${controller}/getCicloOrcamentarioProjetoPacoteExportaExcel/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'relatorioCicloOrcamentarioPacote.xlsx');
      link.setAttribute('id', 'relatorioCicloOrcamentarioPacoteId');
      document.body.appendChild(link);
      link.click();
      document.getElementById('relatorioCicloOrcamentarioPacoteId').outerHTML = '';
    }),
  );
};

export const getCicloOrcamentarioProjetoPacotePluriAnualExportaExcel = (id: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(
      urlBase + `/api/${controller}/getCicloOrcamentarioProjetoPacotePluriAnualExportaExcel/${id}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getJwt()}`,
        },
      },
    ).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'relatorioCicloOrcamentarioPacotePluriAnual.xlsx');
      link.setAttribute('id', 'relatorioCicloOrcamentarioPacotePluriAnualId');
      document.body.appendChild(link);
      link.click();
      document.getElementById('relatorioCicloOrcamentarioPacotePluriAnualId').outerHTML = '';
    }),
  );
};
